import React from 'react'

import styles from './_table.module.scss'

type TableGradientProps = {
  /** Boolean value; Determines whether to apply custom height classes or not.  */
  showStickyClasses: boolean
}

const TableGradient = ({
  showStickyClasses,
}: TableGradientProps): React.JSX.Element => {
  return (
    <div
      className={`${styles.bottomGradient} ${
        showStickyClasses
          ? styles.bottomGradientCustomHeight
          : styles.bottomGradientHeight
      }`}
    />
  )
}

export default TableGradient
